/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { ChatSettingLabel, ChatSettingWrap } from '@views/Popup/Chat/ChatSettingPopup/index.style'
import useRootStore from '@store/useRootStore'

export const UserTitleSetting: React.FC = observer(() => {
  const { authStore } = useRootStore()
  const { userInfo } = authStore

  const toggleUserTitleOptions = () => {
    authStore.updateUserTitleEnabled().catch(console.error)
  }

  return (
    <Fragment>
      <ChatSettingWrap>
        <ul className="setting-list">
          <li className="setting-list--item">
            <p className="setting-tit">
              칭호
              <p className="setting-sub-txt">칭호 및 칭호효과를 적용합니다.</p>
            </p>
            <input
              type="checkbox"
              id="sendMessageToEnter"
              name="sendMessageToEnter"
              value={userInfo.userTitleEnabled ? 1 : 0}
              className="setting-input"
              checked={userInfo.userTitleEnabled}
              disabled/>
            <ChatSettingLabel
              htmlFor="sendMessageToEnter"
              className="on-off-wrap"
              onClick={toggleUserTitleOptions}>
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </ChatSettingLabel>
          </li>
        </ul>
      </ChatSettingWrap>
    </Fragment>
  )
})
